import React, { useState, useEffect } from 'react';
import '../App.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as Strings from './strings'
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import user from '../assets/user.png';
import MyStorage from './util/storage'
import Api from './api/api'

const UserDetails = () => {
    const location = useLocation();
    const user = location.state.user;

    const deleteUser = () => {
        // Api.deleteUser(user.id,
        //     (response) => {
        //         history.goBack()
        //     },
        //     (error) => {
        //         history.goBack()
        //     });
    };

    // const getProfilePhoto = (model) => {
    //     if (MyStorage.getFileUrls() == null || model.photo == null || model.photo === '') {
    //         return user
    //     }
    //     else {
    //         if (model.photo.includes('http')) {
    //             return model.photo
    //         }
    //         return MyStorage.getFileUrls().User + model.photo
    //     }
    // };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    User Details
                </div>
            </div>
            <div style={{ marginTop: 30, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                {/* <img
                    src={getProfilePhoto(user)}
                    style={{ width: 100, height: 100 }} /> */}
                <div style={{ display: 'flex', width: '100%', marginTop: 20, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                    <div style={{ padding: 8, backgroundColor: '#F2F2F2', width: 500, display: 'flex' }}>
                        <div style={{ color: 'gray', marginRight: 10 }}>Name:</div> Saif
                    </div>
                    <div style={{ padding: 8, backgroundColor: '#ffffff', width: 500, display: 'flex' }}>
                        <div style={{ color: 'gray', marginRight: 10 }}>Email:</div> saif052m@gmail.com
                    </div>
                    <div style={{ padding: 8, backgroundColor: '#F2F2F2', width: 500, display: 'flex' }}>
                        <div style={{ color: 'gray', marginRight: 10 }}>Joined:</div> 12-10-2021
                    </div>
                    {/* 
                    <div style={{ display: 'flex', marginTop: 20 }}>
                        <Button
                            className='btn-block btn-submit'
                            style={{ width: 150, marginRight: 10, backgroundColor: 'green', borderWidth: 0, fontSize: 16 }}
                            onClick={() => {
                                console.log('click');
                                history.push({
                                    pathname: '/send-email',
                                    state: { user: user }
                                })
                            }}>
                            Send Email
                        </Button>
                        <Button
                            className='btn-block btn-submit'
                            style={{ width: 200, marginRight: 10, backgroundColor: 'blue', borderWidth: 0, fontSize: 16 }}
                            onClick={() => {
                                console.log('click');
                                history.push({
                                    pathname: '/send-notification',
                                    state: { user: user }
                                })
                            }}>
                            Send Notification
                        </Button>
                        <Button
                            className='btn-block btn-submit'
                            style={{ width: 150, marginRight: 10, backgroundColor: 'purple', borderWidth: 0, fontSize: 16 }}
                            onClick={() => {
                                console.log('click');
                            }}>
                            Chat
                        </Button>
                        <Button
                            className='btn-block btn-submit'
                            style={{ width: 150, backgroundColor: 'red', borderWidth: 0, fontSize: 16 }}
                            onClick={() => {
                                console.log('click');
                                if (window.confirm('Are you sure you wish to delete this user?'))
                                    deleteUser()
                            }}>
                            Delete
                        </Button>
                    </div> */}

                </div>
            </div>
        </div>
    );
}

export default UserDetails;